import React from "react"

export const EditIcon = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5 18.3333H2.5C2.15833 18.3333 1.875 18.05 1.875 17.7083C1.875 17.3667 2.15833 17.0833 2.5 17.0833H17.5C17.8417 17.0833 18.125 17.3667 18.125 17.7083C18.125 18.05 17.8417 18.3333 17.5 18.3333Z"
        fill="#66A57E"
      />
      <path
        d="M15.85 2.9C14.2333 1.28333 12.65 1.24166 10.9916 2.9L9.98331 3.90833C9.89998 3.99167 9.86665 4.125 9.89998 4.24167C10.5333 6.45 12.3 8.21667 14.5083 8.85C14.5416 8.85833 14.575 8.86667 14.6083 8.86667C14.7 8.86667 14.7833 8.83333 14.85 8.76667L15.85 7.75833C16.675 6.94167 17.075 6.15 17.075 5.35C17.0833 4.525 16.6833 3.725 15.85 2.9Z"
        fill="#66A57E"
      />
      <path
        d="M13.0079 9.60834C12.7663 9.49167 12.5329 9.375 12.3079 9.24167C12.1246 9.13334 11.9496 9.01667 11.7746 8.89167C11.6329 8.8 11.4663 8.66667 11.3079 8.53334C11.2913 8.525 11.2329 8.475 11.1663 8.40834C10.8913 8.175 10.5829 7.875 10.3079 7.54167C10.2829 7.525 10.2413 7.46667 10.1829 7.39167C10.0996 7.29167 9.95795 7.125 9.83295 6.93334C9.73295 6.80834 9.61628 6.625 9.50795 6.44167C9.37461 6.21667 9.25795 5.99167 9.14128 5.75834C8.98832 5.43055 8.5581 5.33318 8.30233 5.58895L3.61628 10.275C3.50795 10.3833 3.40795 10.5917 3.38295 10.7333L2.93295 13.925C2.84961 14.4917 3.00795 15.025 3.35795 15.3833C3.65795 15.675 4.07461 15.8333 4.52461 15.8333C4.62461 15.8333 4.72461 15.825 4.82461 15.8083L8.02461 15.3583C8.17461 15.3333 8.38295 15.2333 8.48295 15.125L13.1767 10.4312C13.4274 10.1806 13.3332 9.74928 13.0079 9.60834Z"
        fill="#66A57E"
      />
    </svg>
  )
}
